import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../css/Navbar.css"; // Import the CSS file
import Logo from "../../Svgs/Logo"; // Import the Logo component

const NavigationBar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation(); // Get current location/path

  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState);
  };

  

  // Conditionally apply a background color, text color, and logo color for "Interior Design" pages
  const styledPaths = [
    "/interior-design/commercial",
    "/interior-design",
    "/interior-design/residential",
    "/projects",
    "/interior-design/residential/luxe-residance",
    "/interior-design/residential/beysu-mansions",
    "/interior-design/residential/modern-residence",
    "/interior-design/residential/haven-residence",
    "/interior-design/residential/dual-elegance",
    "/interior-design/residential/light-and-space",
    "/interior-design/residential/conceptual-penthouse",
    "/interior-design/residential/ie-house",
    "/interior-design/residential/private-apartment",
    "/interior-design/residential/sinpas-residences",
  
    "/interior-design/commercial/magellan-restaurant",
    "/interior-design/commercial/radisson-blue",
    "/interior-design/commercial/unodc-centre",
    "/interior-design/commercial/riyadh-turkish",
    "/interior-design/commercial/dawlance-office",
    "/interior-design/commercial/ummbab-tower",
    "/interior-design/commercial/sadko-baku",
    "/interior-design/commercial/wood-atelier",
    "/interior-design/commercial/marriott-residence",
    "/interior-design/commercial/romatem-move",
    "/interior-design/commercial/azel-law",
    "/interior-design/commercial/wander-chocolate",
    "/interior-design/commercial/farm-house",
    "/interior-design/commercial/minimalist-concept",
    "/interior-design/commercial/hair-clinic",


    "/exterior-design",
    "/exterior-design/coastal-contemporary",
    "/exterior-design/modern-harmony",
    "/exterior-design/loca-residences",
    "/exterior-design/villa-facade",
    "/exterior-design/dynamic-urban",
    "/exterior-design/private-villa",
  ];
  

  const navbarStyle = styledPaths.includes(location.pathname)
    ? { backgroundColor: "transparent", color: "#fff" }
    : {};

  // Add a class to the navbar for specific styling on the Interior Design page
  const navbarClass =
    location.pathname === "/interior-design" ||
    location.pathname === "/projects"
      ? "navbar-interior"
      : "";

  return (
    <nav className={`navbar ${navbarClass}`} style={navbarStyle}
      
    >
      <div className="navbar-links">
      <div className="navtitle">
          <h2
            style={{
              fontFamily: "Cinzel-Regular, sans-serif",
              fontWeight: "200",
              color: navbarStyle.color || "#000",
            }}
          >
            A to Z DESIGN STUDIO BY ZEYNEB
          </h2>

          {/* Show image below the title ONLY on "/" and "/home" */}
          {(location.pathname === "/" || location.pathname === "/home") && (
            <img
              src="/Images/emn3.png"
              alt="EMN Logo"
              style={{
              
               marginTop:"10px",
                width: "380px", // Adjust as needed
                height: "auto",
                position:"absolute"
              }}
            />
          )}
        </div>
      </div>

      {/* Centered Logo */}

      <div
        className="navbar-logo"
        style={{
          paddingTop: "10px",
          cursor: "pointer", // This will show a pointer cursor to indicate it's clickable
        }}
        onClick={() => (window.location.href = "/")} // Navigate to "/"
      >
        <Logo color={navbarStyle.color || "#000"} /> {/* Update Logo color */}
      </div>

      <div className="navbar-links">
        <div className="clickablenav">

      
        <Link
          to="/"
          className="nav-link"
          style={{ color: navbarStyle.color || "#000" }}
        >
          HOME
        </Link>
        <Link
          to="/about"
          className="nav-link"
          style={{ color: navbarStyle.color || "#000" }}
        >
          ABOUT
        </Link>

     

        <Link
          to="/projects"
          className="nav-link"
          style={{ color: navbarStyle.color || "#000" }}
        >
          PROJECTS
        </Link>

        <Link
          to="/contact"
          className="nav-link"
          style={{ color: navbarStyle.color || "#000" }}
        >
          CONTACT
        </Link>
        </div>
      </div>

       {/* EMN Logo - Only Visible on Mobile */}
       {window.innerWidth <= 768 && (location.pathname === "/" || location.pathname === "/home") && (
        <img
          src="/Images/emn3.png"
          alt="EMN Logo"
          className="mobile-emn-logo"
        />
      )}
    </nav>
  );
};

export default NavigationBar;
